var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesginIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 78.94 78.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #718e56;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 39.47,
    cy: 39.47,
    r: 39.47
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 38.06,
    y: 22.93,
    width: 28.29,
    height: 8.81,
    transform: "translate(34.62 -28.91) rotate(45)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "43.09 24.46 29.98 29.37 19.19 60.67 49.87 48.24 55.28 36.65"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 39.5,
    cy: 40.04,
    r: 3.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 19.19,
    y1: 60.67,
    x2: 36.85,
    y2: 42.56
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesginIcon);
export default __webpack_public_path__ + "static/media/desgin-icon.64b95506dad925ba2e323f028cdf4c16.svg";
export { ForwardRef as ReactComponent };